import React from 'react'

export default props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="#00112B"
      d="M5.96852 1.83565C6.29197 1.57689 6.34441 1.10492 6.08565 0.781476C5.82689 0.458029 5.35493 0.405588 5.03148 0.664345L2.53148 2.66435C2.20803 2.9231 2.15559 3.39507 2.41435 3.71852C2.67311 4.04196 3.14507 4.09441 3.46852 3.83565L5.96852 1.83565Z"
    />
    <path
      fill="#00112B"
      d="M18.9685 0.664345C18.6451 0.405588 18.1731 0.458029 17.9143 0.781476C17.6556 1.10492 17.708 1.57689 18.0315 1.83565L20.5315 3.83565C20.8549 4.09441 21.3269 4.04196 21.5857 3.71852C21.8444 3.39507 21.792 2.9231 21.4685 2.66435L18.9685 0.664345Z"
    />
    <path
      fill="#00112B"
      d="M12.75 8.25C12.75 7.83578 12.4142 7.5 12 7.5C11.5858 7.5 11.25 7.83578 11.25 8.25V12.4558C11.25 12.7746 11.1282 13.0814 10.9095 13.3133L9.4543 14.8568C9.17015 15.1582 9.18412 15.6329 9.4855 15.917C9.78689 16.2012 10.2616 16.1872 10.5457 15.8858L12.0009 14.3423C12.482 13.832 12.75 13.1572 12.75 12.4558V8.25Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#00112B"
      d="M12 1.49999C6.06294 1.49999 1.25 6.31293 1.25 12.25C1.25 18.1871 6.06294 23 12 23C17.9371 23 22.75 18.1871 22.75 12.25C22.75 6.31293 17.9371 1.49999 12 1.49999ZM2.75 12.25C2.75 7.14136 6.89137 2.99999 12 2.99999C17.1086 2.99999 21.25 7.14136 21.25 12.25C21.25 17.3586 17.1086 21.5 12 21.5C6.89137 21.5 2.75 17.3586 2.75 12.25Z"
    />
  </svg>
)
